/* ============================================================
   cb-facets.js v8 — Cleverbikes Filter
   - Verfügbarkeit komplett ausblenden
   - Standort: Anzeigenamen bereinigen (kein "Store", kein "(E-Bikes)")
   - Hersteller: Case-Duplikate + Markenaliase zusammenfassen
   - Rahmengröße: Duplikate zusammenfassen + sortiert
   - Akkukapazität + Drehmoment: Mindestwert-Chips („500+ Wh“, „70+ Nm“) mit ⓘ
   - Kilometerstand: Höchstwert-Chips („bis 2.500 km“) mit ⓘ
   - Motor: nach Trefferzahl, nur die 3 häufigsten sichtbar, Rest hinter „Mehr anzeigen“
   - Standort „Transporter…“ immer ausgeblendet (Projektregel)
   - Erstzulassung: Von/Bis-Felder auf der Checkbox-Liste
   
   Arbeitet MIT dem bestehenden facets.js zusammen.
   Manipuliert nur Sichtbarkeit + simuliert echte Checkbox-Klicks.
   ============================================================ */
(function() {
  'use strict';

  /* ── Config ── */
  var HIDE_FILTERS = ['verfügbarkeit', 'verfugbarkeit', 'availability'];
  var STANDORT_KEYS = ['standort', 'location', 'store'];
  var HERSTELLER_KEYS = ['hersteller', 'marke', 'manufacturer', 'brand', 'vendor'];
  var FRAME_KEYS = ['rahmengr', 'frame size'];
  var AKKU_KEYS = ['akkukapazit', 'battery'];

  var STANDORT_NAMES = {
    'refurbishmentcenter': 'Refurbishment Center'
  };

  var BRAND_ALIASES = {
    'nox': 'NOX',
    'nox cycles': 'NOX',
    'r raymon': 'Raymon',
    'raymon': 'Raymon'
  };

  /* ── Helpers ── */
  function getFilterTitle(row) {
    var el = row.querySelector('.thb-filter-title');
    return el ? el.textContent.trim().toLowerCase() : '';
  }

  function matchesAny(title, keys) {
    for (var i = 0; i < keys.length; i++) {
      if (title.indexOf(keys[i]) !== -1) return true;
    }
    return false;
  }

  function extractNumber(text) {
    var m = text.match(/(\d+(?:[.,]\d+)?)/);
    if (!m) return null;
    return parseFloat(m[1].replace(',', '.'));
  }

  /* Akku-Wert in Wh: "gesamt 750Wh" hat Vorrang, "2x 375 Wh" = 750, sonst erste Zahl */
  function akkuWh(value) {
    var v = value.toLowerCase();
    var total = v.match(/gesamt\s*(\d+(?:[.,]\d+)?)/);
    if (total) return parseFloat(total[1].replace(',', '.'));
    var multi = v.match(/^\s*(\d+)\s*x\s*(\d+(?:[.,]\d+)?)/);
    if (multi) return parseInt(multi[1], 10) * parseFloat(multi[2].replace(',', '.'));
    return extractNumber(v);
  }

  /* Schreibweisen zusammenfassen: Groß/klein, Leerzeichen, Satzzeichen, „&“/„und“, Akzente, Zusatz „Bikes“ */
  var BRAND_KEY_ALIASES = { 'cubebikes': 'cube', 'stevensbikes': 'stevens', 'bh': 'bhbikes', 'lpmbikes': 'lpm',
    'rraymon': 'raymon', 'liq': 'liqbike', 'kalhoff': 'kalkhoff', 'noxcycles': 'nox', 'urwahnbikes': 'urwahn',
    'propainbikes': 'propain', 'cannondalemoterra': 'cannondale' };
  function canonicalBrand(value) {
    var lower = value.trim().toLowerCase();
    if (BRAND_ALIASES[lower]) return BRAND_ALIASES[lower];
    var key = lower.replace(/\s+und\s+/g, ' ').replace(/&/g, '');
    if (key.normalize) key = key.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    key = key.replace(/[^a-z0-9]/g, '');
    return BRAND_KEY_ALIASES[key] || key;
  }

  function bestDisplayName(names) {
    for (var i = 0; i < names.length; i++) {
      var lower = names[i].trim().toLowerCase();
      if (BRAND_ALIASES[lower]) return BRAND_ALIASES[lower];
    }
    var titleCase = null;
    var allCaps = null;
    for (var j = 0; j < names.length; j++) {
      var n = names[j].trim();
      if (n === n.toUpperCase()) {
        if (!allCaps) allCaps = n;
      } else {
        if (!titleCase) titleCase = n;
      }
    }
    return titleCase || allCaps || names[0];
  }

  /* ── Hauptlogik ── */
  function processAll() {
    var rows = document.querySelectorAll('collapsible-row');
    rows.forEach(function(row) {
      var title = getFilterTitle(row);
      if (!title) return;

      if (matchesAny(title, HIDE_FILTERS)) {
        row.style.display = 'none';
        return;
      }

      if (matchesAny(title, STANDORT_KEYS)) {
        if (row.getAttribute('data-cbf-done') !== 'true') {
          normalizeStandort(row);
          row.setAttribute('data-cbf-done', 'true');
        }
        return;
      }

      if (matchesAny(title, HERSTELLER_KEYS)) {
        if (row.getAttribute('data-cbf-done') !== 'true') {
          normalizeHersteller(row);
          row.setAttribute('data-cbf-done', 'true');
        }
        return;
      }

      if (matchesAny(title, FRAME_KEYS)) {
        if (row.getAttribute('data-cbf-done') !== 'true') {
          normalizeFrameSize(row);
          row.setAttribute('data-cbf-done', 'true');
        }
        return;
      }

      if (row.querySelector('input[type="checkbox"][name="' + KM_PARAM + '"]')) {
        if (row.getAttribute('data-cbf-done') !== 'true') {
          groupStufenChips(row, KM_CHIPS);
          row.setAttribute('data-cbf-done', 'true');
        }
        return;
      }

      if (row.querySelector('input[type="checkbox"][name="' + NM_PARAM + '"]')) {
        if (row.getAttribute('data-cbf-done') !== 'true') {
          groupMinChips(row, NM_CHIPS);
          row.setAttribute('data-cbf-done', 'true');
        }
        return;
      }

      if (row.querySelector('input[type="checkbox"][name="' + MOTOR_PARAM + '"]')) {
        if (row.getAttribute('data-cbf-done') !== 'true') {
          compactList(row, MOTOR_VISIBLE);
          row.setAttribute('data-cbf-done', 'true');
        }
        return;
      }

      var rangeCfg = rangeListConfig(row);
      if (rangeCfg) {
        if (row.getAttribute('data-cbf-done') !== 'true') {
          groupRangeList(row, rangeCfg);
          row.setAttribute('data-cbf-done', 'true');
        }
        return;
      }

      if (matchesAny(title, AKKU_KEYS)) {
        if (row.getAttribute('data-cbf-done') !== 'true') {
          groupMinChips(row, AKKU_CHIPS);
          row.setAttribute('data-cbf-done', 'true');
        }
        return;
      }
    });
  }

  /* ── Standort ── */
  function normalizeStandort(row) {
    var items = row.querySelectorAll('.thb-filter-content ul li');
    items.forEach(function(li) {
      var cb = li.querySelector('input[type="checkbox"]');
      if (!cb) return;
      var rawValue = cb.value.trim();
      var lower = rawValue.toLowerCase();
      /* Projektregel: Standort „Transporter…“ ist für Kunden immer ausgeblendet */
      if (lower.indexOf('transporter') === 0) {
        li.style.display = 'none';
        li.setAttribute('data-cbf-dup', '1');
        return;
      }
      var displayName;
      if (STANDORT_NAMES[lower]) {
        displayName = STANDORT_NAMES[lower];
      } else {
        displayName = rawValue.replace(/^Store\s+/i, '');
        displayName = displayName.replace(/\s*\([^)]*(?:bike|rad|e-|fahrr)[^)]*\)/i, '');
      }
      displayName = displayName.trim();
      var textEl = li.querySelector('.thb-filter-text');
      if (textEl && displayName) textEl.textContent = displayName;
      var labelEl = li.querySelector('label');
      if (labelEl && displayName) {
        var countEl = li.querySelector('.count');
        var countText = countEl ? countEl.textContent.trim() : '';
        labelEl.setAttribute('data-tooltip', displayName + (countText ? ' (' + countText + ')' : ''));
      }
    });
  }

  /* ── Hersteller ── */
  function normalizeHersteller(row) {
    var items = row.querySelectorAll('.thb-filter-content ul li');
    var groups = {};
    var order = [];

    items.forEach(function(li) {
      var cb = li.querySelector('input[type="checkbox"]');
      if (!cb) return;
      var rawName = cb.value.trim();
      var key = canonicalBrand(rawName);
      if (!groups[key]) {
        groups[key] = { items: [], cbs: [], names: [], totalCount: 0, primaryLi: null, primaryCb: null, anyChecked: false };
        order.push(key);
      }
      var g = groups[key];
      g.items.push(li);
      g.cbs.push(cb);
      g.names.push(rawName);
      if (cb.checked) g.anyChecked = true;
      var countEl = li.querySelector('.count');
      if (countEl) g.totalCount += parseInt(countEl.textContent.replace(/[()]/g, '').trim()) || 0;
    });

    order.forEach(function(key) {
      var g = groups[key];
      if (g.items.length <= 1) return;
      var displayName = bestDisplayName(g.names);
      g.primaryLi = g.items[0];
      g.primaryCb = g.cbs[0];
      var primaryText = g.primaryLi.querySelector('.thb-filter-text');
      if (primaryText) primaryText.textContent = displayName;
      var primaryCount = g.primaryLi.querySelector('.count');
      if (primaryCount) primaryCount.textContent = g.totalCount;
      var primaryLabel = g.primaryLi.querySelector('label');
      if (primaryLabel) primaryLabel.setAttribute('data-tooltip', displayName + ' (' + g.totalCount + ')');
      for (var i = 1; i < g.items.length; i++) g.items[i].style.display = 'none';
      (function(grp) {
        grp.primaryCb.addEventListener('change', function() {
          var checked = grp.primaryCb.checked;
          for (var i = 1; i < grp.cbs.length; i++) {
            if (grp.cbs[i].checked !== checked) grp.cbs[i].checked = checked;
          }
        });
      })(g);
    });

    compactBrands(row, groups, order);
    updateMoreButton(row);
  }

  /* Marken kompakt: nach Trefferzahl sortiert (größte zuerst), nur die 4 häufigsten sichtbar,
     Rest hinter „Mehr anzeigen“; dazu ein Suchfeld „Marke suchen …“ */
  /* Motor: nach Trefferzahl sortiert (größte zuerst), nur die 3 häufigsten sichtbar, Rest hinter „Mehr anzeigen“ */
  var MOTOR_PARAM = 'filter.p.m.custom.filter_motor';
  var MOTOR_VISIBLE = 3;
  function compactList(row, visibleCount) {
    var ul = row.querySelector('.thb-filter-content ul');
    if (!ul) return;
    var hiddenClass = 'thb-filter-content--hidden';
    var items = [];
    ul.querySelectorAll('li').forEach(function(li) {
      var cb = li.querySelector('input[type="checkbox"]');
      if (!cb) return;
      items.push({ li: li, checked: cb.checked,
        count: parseInt(((li.querySelector('.count') || {}).textContent || '').replace(/[()]/g, ''), 10) || 0,
        name: ((li.querySelector('.thb-filter-text') || {}).textContent || cb.value).trim() });
    });
    /* Gewählte bleiben oben sichtbar, dann nach Trefferzahl, bei Gleichstand alphabetisch */
    items.sort(function(a, b) {
      if (a.checked !== b.checked) return a.checked ? -1 : 1;
      return b.count - a.count || a.name.localeCompare(b.name, 'de');
    });
    var visible = 0;
    items.forEach(function(e) {
      ul.appendChild(e.li);
      var show = e.checked || visible < visibleCount;
      if (show) visible++;
      e.li.classList.toggle(hiddenClass, !show);
    });
    updateMoreButton(row);
  }

  var BRANDS_VISIBLE = 4;
  function compactBrands(row, groups, order) {
    var ul = row.querySelector('.thb-filter-content ul');
    if (!ul) return;
    var hiddenClass = 'thb-filter-content--hidden';
    var lead = order.map(function(k) {
      var g = groups[k];
      var count = g.items.length > 1 ? g.totalCount : (parseInt(((g.items[0].querySelector('.count') || {}).textContent || '').replace(/[()]/g, ''), 10) || 0);
      return { li: g.items[0], dups: g.items.slice(1), count: count, checked: g.anyChecked,
               name: ((g.items[0].querySelector('.thb-filter-text') || {}).textContent || '').trim() };
    });
    /* Gewählte Marken bleiben oben sichtbar, dann nach Trefferzahl, bei Gleichstand alphabetisch */
    lead.sort(function(a, b) {
      if (a.checked !== b.checked) return a.checked ? -1 : 1;
      return b.count - a.count || a.name.localeCompare(b.name, 'de');
    });
    var visible = 0;
    lead.forEach(function(e) {
      ul.appendChild(e.li);
      e.dups.forEach(function(d) { d.setAttribute('data-cbf-dup', '1'); ul.appendChild(d); });
      var show = e.checked || visible < BRANDS_VISIBLE;
      if (show) visible++;
      e.li.classList.toggle(hiddenClass, !show);
    });

    var content = row.querySelector('.thb-filter-content');
    if (!content || content.querySelector('.cbf-search')) return;
    var search = document.createElement('input');
    search.type = 'search';
    search.className = 'cbf-search';
    search.placeholder = 'Marke suchen …';
    search.setAttribute('aria-label', 'Marke suchen');
    search.autocomplete = 'off';
    var noHit = document.createElement('p');
    noHit.className = 'cbf-hint cbf-search-empty';
    noHit.textContent = 'Keine passende Marke.';
    noHit.hidden = true;
    var btn = row.querySelector('.thb-filter-content--button');
    var wasOpen = false;

    function apply() {
      var q = search.value.trim().toLowerCase();
      var hits = 0;
      if (q && !wasOpen) wasOpen = ul.hasAttribute('filters-open') ? 'user' : true;
      lead.forEach(function(e) {
        /* Treffer am Wortanfang: „ri“ → Riese & Müller, nicht Victoria */
        var match = !q || (' ' + e.name.toLowerCase()).indexOf(' ' + q) !== -1;
        e.li.style.display = match ? '' : 'none';
        if (match) hits++;
      });
      if (q) {
        ul.setAttribute('filters-open', '');
        if (btn) btn.style.display = 'none';
      } else {
        if (wasOpen !== 'user') ul.removeAttribute('filters-open');
        wasOpen = false;
        if (btn) btn.style.display = '';
        updateMoreButton(row);
      }
      noHit.hidden = !(q && hits === 0);
    }
    /* Eingaben gehören nicht zum Filterformular: nicht an facets.js weiterreichen */
    search.addEventListener('input', function(e) { e.stopPropagation(); apply(); });
    search.addEventListener('keydown', function(e) { if (e.key === 'Enter') e.preventDefault(); });
    content.insertBefore(search, ul);
    content.insertBefore(noHit, ul);
  }

  function updateMoreButton(row) {
    var ul = row.querySelector('.thb-filter-content ul');
    if (!ul) return;
    var hiddenClass = 'thb-filter-content--hidden';
    var hidCount = 0;
    ul.querySelectorAll('li:not([style*="display: none"])').forEach(function(li) {
      if (li.classList.contains(hiddenClass)) hidCount++;
    });
    var btn = row.querySelector('.thb-filter-content--button');
    /* Das Theme legt „Mehr anzeigen“ nur bei mehr als 5 Einträgen an – sind trotzdem welche versteckt, Knopf ergänzen */
    if (!btn && hidCount > 0) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'thb-filter-content--button text-button';
      btn.textContent = (window.theme && theme.strings && theme.strings.showMore) || 'Mehr anzeigen';
      ul.parentNode.insertBefore(btn, ul.nextSibling);
    }
    if (btn) btn.style.display = hidCount === 0 ? 'none' : '';
  }

  /* ── Rahmengröße ── */
  function normalizeFrameSize(row) {
    var ul = row.querySelector('.thb-filter-content ul');
    var items = row.querySelectorAll('.thb-filter-content ul li');
    if (!ul || !items.length) return;

    var SIZE_ORDER = { 'xxs': 1, 'xs': 2, 's': 3, 'm': 4, 'l': 5, 'xl': 6, 'xxl': 7, 'xxxl': 8 };

    function getSortKey(li) {
      var cb = li.querySelector('input[type="checkbox"]');
      if (!cb) return { type: 2, order: 9999 };
      var val = (cb.value || '').trim();
      var textEl = li.querySelector('.thb-filter-text');
      var text = textEl ? textEl.textContent.trim() : val;
      var letterMatch = text.match(/^(x{0,3}s|x{0,3}l|m)$/i);
      if (!letterMatch) {
        var bracketMatch = val.match(/\((\w+)\)/);
        if (bracketMatch) {
          var inner = bracketMatch[1].toLowerCase();
          if (SIZE_ORDER[inner]) return { type: 0, order: SIZE_ORDER[inner] };
        }
      }
      if (letterMatch) {
        var key = letterMatch[1].toLowerCase();
        if (SIZE_ORDER[key]) return { type: 0, order: SIZE_ORDER[key] };
      }
      var num = extractNumber(val);
      if (num !== null) return { type: 1, order: num };
      return { type: 2, order: 9999 };
    }

    var sortable = [];
    items.forEach(function(li) { sortable.push({ li: li, key: getSortKey(li) }); });
    sortable.sort(function(a, b) {
      if (a.key.type !== b.key.type) return a.key.type - b.key.type;
      return a.key.order - b.key.order;
    });
    sortable.forEach(function(entry) { ul.appendChild(entry.li); });
  }

  /* ── Mindestwert-Chips: Akku „300+ Wh“ … „700+ Wh“, Drehmoment „50+ Nm“ … „90+ Nm“ ──
     Die echten Shopify-Checkboxen bleiben (versteckt) im Formular. Ein Chip setzt
     alle Werte ab dieser Stufe; nochmal klicken hebt den Filter auf.
     Nur ein Chip ist aktiv (Mindestwerte schließen sich gegenseitig ein). */
  var AKKU_CHIPS = {
    key: 'akku', steps: [300, 400, 500, 600, 700], unit: 'Wh', valueOf: akkuWh,
    label: 'Akkukapazität',
    hint: 'Zeigt alle Räder mit mindestens dieser Akkukapazität, z. B. „500+ Wh“ = ab 500 Wh.'
  };
  var NM_PARAM = 'filter.p.m.custom.filter_drehmoment_nm';
  var NM_CHIPS = {
    key: 'nm', steps: [50, 60, 70, 80, 90], unit: 'Nm',
    valueOf: function(v) { var n = Number(v); return isNaN(n) ? null : n; },
    label: 'Drehmoment', title: 'Drehmoment Motor',
    hint: 'Das Drehmoment zeigt, wie kräftig der Motor anschiebt – wichtig am Berg und beim Anfahren. „70+ Nm“ = ab 70 Nm.'
  };

  function groupMinChips(row, cfg) {
    var content = row.querySelector('.thb-filter-content');
    var ul = row.querySelector('.thb-filter-content ul');
    if (!content || !ul) return;

    var entries = [];
    ul.querySelectorAll('li').forEach(function(li) {
      var cb = li.querySelector('input[type="checkbox"]');
      if (cb) entries.push({ cb: cb, val: cfg.valueOf(cb.value || '') });
    });
    if (!entries.length) return;

    /* Aktiver Chip = größte Stufe, die der kleinste gewählte Wert erreicht */
    var minChecked = null;
    entries.forEach(function(e) {
      if (e.cb.checked && e.val !== null && (minChecked === null || e.val < minChecked)) minChecked = e.val;
    });
    var activeStep = null;
    cfg.steps.forEach(function(step) {
      if (minChecked !== null && minChecked >= step) activeStep = step;
    });

    /* Originalliste und „Mehr anzeigen“ ausblenden */
    ul.style.display = 'none';
    var moreBtn = row.querySelector('.thb-filter-content--button');
    if (moreBtn) moreBtn.style.display = 'none';

    var formId = (row.closest('form') || {}).id || cfg.key;
    var chips = document.createElement('div');
    chips.className = 'cbf-chips';
    chips.setAttribute('role', 'group');
    chips.setAttribute('aria-label', cfg.label + ' mindestens');

    cfg.steps.forEach(function(step) {
      var matches = entries.filter(function(e) { return e.val !== null && e.val >= step && !e.cb.disabled; });
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.id = formId + '-' + cfg.key + '-min-' + step;
      btn.className = 'cbf-chip';
      btn.textContent = step + '+ ' + cfg.unit;
      btn.setAttribute('aria-pressed', step === activeStep ? 'true' : 'false');
      if (!matches.length && step !== activeStep) btn.disabled = true;

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var turnOff = step === activeStep;
        entries.forEach(function(entry) {
          entry.cb.checked = !turnOff && entry.val !== null && entry.val >= step && !entry.cb.disabled;
        });
        /* Input-Event auf eine echte Checkbox → facets.js filtert */
        entries[0].cb.dispatchEvent(new Event('input', { bubbles: true }));
      });
      chips.appendChild(btn);
    });

    var hint = document.createElement('p');
    hint.className = 'cbf-hint';
    hint.textContent = cfg.hint;

    content.insertBefore(hint, content.firstChild);
    content.insertBefore(chips, hint.nextSibling);

    if (cfg.title) setFilterTitle(row, cfg.title);
    addInfoIcon(row, cfg.label, cfg.hint);
  }

  /* ── Kilometerstand: Höchstwert-Chips „bis 500 km“ … „bis 10.000 km“ ──
     Jedes Rad trägt alle Stufen, unter denen es liegt (custom.filter_km_stufen, Filterpflege-Skript).
     Ein Chip setzt genau diesen einen Wert → kurze URL; nochmal klicken hebt den Filter auf. */
  var KM_PARAM = 'filter.p.m.custom.filter_km_stufen';
  var KM_CHIPS = {
    key: 'km', label: 'Kilometerstand',
    stufen: ['bis 500 km', 'bis 1.000 km', 'bis 2.500 km', 'bis 5.000 km', 'bis 10.000 km'],
    hint: 'Zeigt alle Räder mit höchstens diesem Kilometerstand, z. B. „bis 2.500 km“ = 0 bis 2.500 km.'
  };

  function groupStufenChips(row, cfg) {
    var content = row.querySelector('.thb-filter-content');
    var ul = row.querySelector('.thb-filter-content ul');
    if (!content || !ul) return;
    var boxes = {};
    ul.querySelectorAll('input[type="checkbox"]').forEach(function(cb) { boxes[cb.value] = cb; });

    ul.style.display = 'none';
    var moreBtn = row.querySelector('.thb-filter-content--button');
    if (moreBtn) moreBtn.style.display = 'none';

    var formId = (row.closest('form') || {}).id || cfg.key;
    var chips = document.createElement('div');
    chips.className = 'cbf-chips';
    chips.setAttribute('role', 'group');
    chips.setAttribute('aria-label', cfg.label + ' höchstens');
    cfg.stufen.forEach(function(stufe, i) {
      var cb = boxes[stufe];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.id = formId + '-' + cfg.key + '-' + i;
      btn.className = 'cbf-chip';
      btn.textContent = stufe;
      var active = !!(cb && cb.checked);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (!cb || (cb.disabled && !active)) btn.disabled = true;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!cb) return;
        var turnOn = !cb.checked;
        Object.keys(boxes).forEach(function(k) { boxes[k].checked = false; });
        cb.checked = turnOn;
        cb.dispatchEvent(new Event('input', { bubbles: true }));
      });
      chips.appendChild(btn);
    });

    var hint = document.createElement('p');
    hint.className = 'cbf-hint';
    hint.textContent = cfg.hint;
    content.insertBefore(hint, content.firstChild);
    content.insertBefore(chips, hint.nextSibling);
    addInfoIcon(row, cfg.label, cfg.hint);
  }

  /* Sichtbaren Gruppentitel ändern (Label in Search & Discovery bleibt) */
  function setFilterTitle(row, text) {
    var summary = row.querySelector('summary.thb-filter-title');
    if (!summary) return;
    for (var i = 0; i < summary.childNodes.length; i++) {
      var n = summary.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = text + ' '; return; }
    }
  }

  /* ── Zahlen-Listen (Erstzulassung) als Von/Bis-Felder ──
     Search & Discovery liefert Ganzzahl-Metafelder als Checkbox-Liste (je Wert ein Kästchen).
     Die Liste bleibt versteckt im Formular; „Von/Bis“ hakt alle Werte im Bereich an
     (Abschicken: cb-range-Handler unten, bei Enter oder beim Verlassen des Feldes). */
  var RANGE_LISTS = [
    { param: 'filter.p.m.custom.filter_erstzulassung', unit: '' }
  ];

  function rangeListConfig(row) {
    for (var i = 0; i < RANGE_LISTS.length; i++) {
      if (row.querySelector('input[type="checkbox"][name="' + RANGE_LISTS[i].param + '"]')) return RANGE_LISTS[i];
    }
    return null;
  }

  function groupRangeList(row, cfg) {
    var content = row.querySelector('.thb-filter-content');
    var ul = row.querySelector('.thb-filter-content ul');
    if (!content || !ul) return;
    var nums = [], checked = [];
    ul.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      var n = Number(cb.value);
      if (isNaN(n)) return;
      nums.push(n);
      if (cb.checked) checked.push(n);
    });
    if (!nums.length) return;
    var min = Math.min.apply(null, nums), max = Math.max.apply(null, nums);

    ul.style.display = 'none';
    var moreBtn = row.querySelector('.thb-filter-content--button');
    if (moreBtn) moreBtn.style.display = 'none';

    var base = ((row.closest('form') || {}).id || 'f') + '-' + cfg.param.split('.').pop();
    var unit = cfg.unit ? '<span class="cb-range__unit" aria-hidden="true">' + cfg.unit + '</span>' : '';
    var label = (row.querySelector('.thb-filter-title') || {}).textContent || '';
    function field(kind, text, value, placeholder) {
      return '<div class="cb-range__field"><label class="cb-range__label" for="' + base + '-' + kind + '">' + text + '</label>' +
        '<span class="cb-range__box"><input class="cb-range__input" id="' + base + '-' + kind + '" data-cb-kind="' + kind + '"' +
        ' value="' + value + '" placeholder="' + placeholder + '" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="7" autocomplete="off"' +
        ' aria-label="' + label.trim() + ' ' + text.toLowerCase() + (cfg.unit ? ' (' + cfg.unit + ')' : '') + '">' + unit + '</span></div>';
    }
    var wrap = document.createElement('div');
    wrap.className = 'cb-range';
    wrap.setAttribute('data-cb-list', 'true');
    /* Offene Seite (Bereich reicht bis zum kleinsten/größten Wert) bleibt leer */
    var vMin = checked.length ? Math.min.apply(null, checked) : null;
    var vMax = checked.length ? Math.max.apply(null, checked) : null;
    wrap.innerHTML =
      field('min', 'Von', vMin !== null && vMin > min ? vMin : '', min) +
      field('max', 'Bis', vMax !== null && vMax < max ? vMax : '', max) +
      '<p class="cb-range__hint" hidden>Keine Räder in diesem Bereich.</p>';
    content.insertBefore(wrap, content.firstChild);
  }

  /* ⓘ neben dem Titel: blendet den Erklärtext ein/aus, ohne die Gruppe auf-/zuzuklappen */
  function addInfoIcon(row, label, hintText) {
    var summary = row.querySelector('summary');
    if (!summary || summary.querySelector('.cbf-info')) return;
    var info = document.createElement('i');
    info.className = 'cbf-info';
    info.setAttribute('role', 'button');
    info.setAttribute('tabindex', '0');
    info.setAttribute('aria-label', 'Info zu ' + label);
    info.setAttribute('title', hintText);
    function toggle(e) {
      e.preventDefault();
      e.stopPropagation();
      row.classList.toggle('cbf-hint-open');
      var details = row.querySelector('details');
      if (details && !details.open) details.open = true;
    }
    info.addEventListener('click', toggle);
    info.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') toggle(e);
    });
    var arrow = summary.querySelector('span');
    summary.insertBefore(info, arrow || null);
  }

  /* ── Init + Observer ── */
  function init() {
    processAll();
    /* Synchron nach jedem Filterklick, bevor der Browser zeichnet → kein Springen */
    document.addEventListener('facets:updated', processAll);

    var target = document.getElementById('ProductGridContainer');
    if (target) {
      var gridObserver = new MutationObserver(function() {
        /* Nur Fallback: facets.js löst nach jedem Filterklick 'facets:updated' aus.
           Bereits aufbereitete Gruppen (data-cbf-done) nicht erneut anfassen,
           sonst doppeln sich Akku-Gruppen und Hersteller-Zahlen. */
        setTimeout(processAll, 200);
      });
      gridObserver.observe(target, { childList: true, subtree: false });
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:unload', function(e) {
          if (e.target.contains(target)) {
            gridObserver.disconnect();
          }
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ══════════════════════════════════════════════════════════════
   CB CUSTOM: Handy-Filterleiste – nur die ersten 4 Gruppen aufgeklappt
   (Größe und Körpergröße zählen zusammen als eine). Läuft einmal beim Laden;
   danach merkt sich facets.js den Zustand selbst (captureState/restoreState).
   ══════════════════════════════════════════════════════════════ */
(function() {
  var OPEN_SLOTS = 4;
  function paramOf(row) {
    var i = row.querySelector('input[name^="filter."]');
    return i ? i.name : '';
  }
  function collapseMobile() {
    var form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    var slot = 0, prev = '';
    form.querySelectorAll('collapsible-row').forEach(function(row) {
      if (row.style.display === 'none') return;
      var details = row.querySelector('details');
      if (!details) return;
      var param = paramOf(row);
      var isKg = row.classList.contains('cb-kg-row') || param.indexOf('koerpergroesse') !== -1;
      var paired = isKg && prev.indexOf('filter_groesse') !== -1;
      if (!paired) slot++;
      prev = param;
      details.open = slot <= OPEN_SLOTS;
    });
  }
  /* nach cb-facets (versteckt Verfügbarkeit u. a.), damit nur sichtbare Gruppen zählen */
  function run() { setTimeout(collapseMobile, 0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* ══════════════════════════════════════════════════════════════
   CB CUSTOM: Von/Bis-Felder für Zahlen-Filter (snippets/cb-facet-range.liquid)
   - nur Ziffern (kein Tausenderpunkt, Jahr bleibt „2021“)
   - filtert erst bei Enter oder beim Verlassen des Feldes, nicht bei jedem
     Tastendruck (sonst wird das Feld mitten im Tippen neu gezeichnet)
   - „Von“ größer als „Bis“ → Werte tauschen
   Delegiert am document: gilt auch für neu gezeichnete Filter.
   ══════════════════════════════════════════════════════════════ */
(function() {
  function isRangeInput(el) {
    return el && el.classList && el.classList.contains('cb-range__input');
  }

  function submit(input) {
    var range = input.closest('.cb-range');
    var form = input.closest('form');
    if (!range || !form) return;
    var fields = range.querySelectorAll('.cb-range__input');
    if (fields.length === 2 && fields[0].value !== '' && fields[1].value !== '' &&
        Number(fields[0].value) > Number(fields[1].value)) {
      var tmp = fields[0].value;
      fields[0].value = fields[1].value;
      fields[1].value = tmp;
    }
    if (input.dataset.cbSent === input.value) return;
    input.dataset.cbSent = input.value;
    if (range.getAttribute('data-cb-list') === 'true' && !applyToList(range, fields)) return;
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* Listen-Modus: alle Kästchen im Bereich anhaken. false = kein Wert im Bereich (nicht filtern, Hinweis zeigen) */
  function applyToList(range, fields) {
    var row = range.closest('collapsible-row') || range.parentNode;
    var von = fields[0].value === '' ? null : Number(fields[0].value);
    var bis = fields[1].value === '' ? null : Number(fields[1].value);
    var boxes = row.querySelectorAll('ul input[type="checkbox"]');
    var hint = range.querySelector('.cb-range__hint');
    var hits = 0;
    boxes.forEach(function(cb) {
      var n = Number(cb.value);
      var on = (von !== null || bis !== null) && !cb.disabled &&
        (von === null || n >= von) && (bis === null || n <= bis);
      if (on) hits++;
      cb.dataset.cbWanted = on ? '1' : '';
    });
    if ((von !== null || bis !== null) && hits === 0) {
      if (hint) hint.hidden = false;
      return false;
    }
    if (hint) hint.hidden = true;
    boxes.forEach(function(cb) { cb.checked = cb.dataset.cbWanted === '1'; });
    return true;
  }

  /* Capture-Phase: Tastendrücke erreichen den Sofort-Filter von facets.js nicht */
  document.addEventListener('input', function(e) {
    if (!isRangeInput(e.target)) return;
    e.stopPropagation();
    var digits = e.target.value.replace(/\D+/g, '');
    if (digits !== e.target.value) e.target.value = digits;
  }, true);

  document.addEventListener('change', function(e) {
    if (isRangeInput(e.target)) submit(e.target);
  }, true);

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' || !isRangeInput(e.target)) return;
    e.preventDefault();
    submit(e.target);
  }, true);

  /* Ausgangswert merken, damit unveränderte Felder beim Verlassen nichts auslösen */
  document.addEventListener('focusin', function(e) {
    if (isRangeInput(e.target)) e.target.dataset.cbSent = e.target.value;
  }, true);
})();

/* ══════════════════════════════════════════════════════════════
   CB CUSTOM: Standort-Labels umbenennen
   "Köln" → "Köln (E-Bikes)" / "Köln (Bio-Bikes)"
   ══════════════════════════════════════════════════════════════ */
(function() {
  var STANDORT_LABEL_MAP = {
    'Store Köln (E-Bikes)':    'Köln (E-Bikes)',
    'Store Köln (Bio-Bikes)':  'Köln (Bio-Bikes)'
  };

  function rewriteStandortLabels() {
    var checkboxes = document.querySelectorAll('input[name="filter.p.m.global.standort"]');
    checkboxes.forEach(function(cb) {
      var newLabel = STANDORT_LABEL_MAP[cb.value];
      if (!newLabel) return;

      var li = cb.closest('li');
      if (!li) return;

      var textEl = li.querySelector('.thb-filter-text');
      if (textEl && textEl.textContent.trim() !== newLabel) {
        textEl.textContent = newLabel;
      }

      /* Tooltip mit aktualisieren (für Hover-Konsistenz) */
      var label = li.querySelector('label');
      if (label && label.hasAttribute('data-tooltip')) {
        var count = li.querySelector('.count');
        var countTxt = count ? ' (' + count.textContent.trim() + ')' : '';
        label.setAttribute('data-tooltip', newLabel + countTxt);
      }
    });
  }

  /* Initial + nach jedem AJAX-Update */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteStandortLabels);
  } else {
    rewriteStandortLabels();
  }
  document.addEventListener('facets:updated', rewriteStandortLabels);

  var target = document.getElementById('ProductGridContainer');
  if (target) {
    new MutationObserver(function() {
      setTimeout(rewriteStandortLabels, 50);
    }).observe(target, { childList: true, subtree: true });
  }
})();

/* ══════════════════════════════════════════════════════════════
   CB CUSTOM: Standort "Store Köln (E-Bike)" Singular mergen mit
   "Store Köln (E-Bikes)" Plural — Workaround für Xentral-
   Dateninkonsistenz (~10 Bikes haben fälschlich den Singular-Wert).
   
   Wichtig: Checkboxen existieren MEHRFACH im DOM (Mobile-Drawer
   + Desktop-Sidebar), deshalb iterieren wir über alle Vorkommen.
   
   TODO: Sobald die Daten in Xentral konsistent sind, raus damit.
   ══════════════════════════════════════════════════════════════ */
(function() {
  var SINGULAR_VALUE = 'Store Köln (E-Bike)';
  var PLURAL_VALUE   = 'Store Köln (E-Bikes)';

  function mergeKoelnEBikes() {
    /* Alle Singular-Checkboxen (Mobile + Desktop) */
    var singularCbs = document.querySelectorAll(
      'input[name="filter.p.m.global.standort"][value="' + SINGULAR_VALUE + '"]'
    );
    /* Alle Plural-Checkboxen (Mobile + Desktop) */
    var pluralCbs = document.querySelectorAll(
      'input[name="filter.p.m.global.standort"][value="' + PLURAL_VALUE + '"]'
    );

    if (!singularCbs.length || !pluralCbs.length) return;

    /* Beide Listen paaren — pro Vorkommen einmal mergen */
    var pairCount = Math.min(singularCbs.length, pluralCbs.length);

    for (var i = 0; i < pairCount; i++) {
      var singularCb = singularCbs[i];
      var pluralCb   = pluralCbs[i];
      var singularLi = singularCb.closest('li');
      var pluralLi   = pluralCb.closest('li');
      if (!singularLi || !pluralLi) continue;

      /* Counts auslesen und zusammenführen — nur einmal pro Render */
      if (!pluralLi.dataset.cbMerged) {
        var singularCountEl = singularLi.querySelector('.count');
        var pluralCountEl   = pluralLi.querySelector('.count');
        var singularCount   = singularCountEl ? parseInt(singularCountEl.textContent.trim(), 10) || 0 : 0;
        var pluralCount     = pluralCountEl ? parseInt(pluralCountEl.textContent.trim(), 10) || 0 : 0;
        var mergedCount     = singularCount + pluralCount;

        if (pluralCountEl) {
          pluralCountEl.textContent = mergedCount;
        }

        var pluralLabel = pluralLi.querySelector('label');
        if (pluralLabel && pluralLabel.hasAttribute('data-tooltip')) {
          var textEl = pluralLi.querySelector('.thb-filter-text');
          var displayName = textEl ? textEl.textContent.trim() : 'Köln (E-Bikes)';
          pluralLabel.setAttribute('data-tooltip', displayName + ' (' + mergedCount + ')');
        }

        pluralLi.dataset.cbMerged = '1';
      }

      /* Singular-Eintrag visuell ausblenden */
      singularLi.style.display = 'none';

      /* Checkbox-Sync: Klick auf Plural → Singular auch aktivieren */
      if (!pluralCb.dataset.cbSyncBound) {
        (function(sCb, pCb) {
          pCb.addEventListener('change', function() {
            sCb.checked = pCb.checked;
          });
        })(singularCb, pluralCb);
        pluralCb.dataset.cbSyncBound = '1';
      }

      /* Falls URL den Singular-Filter aktiv hat: Plural mit aktivieren */
      if (singularCb.checked && !pluralCb.checked) {
        pluralCb.checked = true;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mergeKoelnEBikes);
  } else {
    mergeKoelnEBikes();
  }
  document.addEventListener('facets:updated', mergeKoelnEBikes);

  /* Nach jedem AJAX-Update der Facets erneut anwenden */
  var target = document.getElementById('ProductGridContainer');
  if (target) {
    new MutationObserver(function() {
      setTimeout(mergeKoelnEBikes, 50);
    }).observe(target, { childList: true, subtree: true });
  }
})();